import React, { createContext, useState, useContext } from 'react';

const AlertContext = createContext();

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);
  const showAlert = (message, type = 'info') => setAlert({ message, type });
  const hideAlert = () => setAlert(null);

  return (
    <AlertContext.Provider value={{ alert, showAlert, hideAlert }}>
      {children}
      {alert && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-lg text-center">
            <span className={`text-lg font-bold mb-2 text-${alert.type === 'error' ? 'red' : 'blue'}-600`}>{alert.type.toUpperCase()}</span>
            <p className="mb-4">{alert.message}</p>
            <button className="px-4 py-2 bg-blue-500 text-white rounded" onClick={hideAlert}>Close</button>
          </div>
        </div>
      )}
    </AlertContext.Provider>
  );
};
